import React from 'react';
import PropTypes from 'prop-types';
import { ContentSwitch } from 'Components';
import Fetch from 'helpers/fetch';
import { buildUrl } from 'helpers/misc';
import i18n from 'i18next';
import AppContext from 'src/AppContext';
import log from 'loglevel';
import { PINFILTERITEM, FILTERITEMS } from 'constants/apis';
import NavDesktop from './NavDesktop/NavDesktop';
import NavMobile from './NavMobile/NavMobile';

class Nav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ViewMore: false,
      mobileActiveMenu: null,
      filterItems: {
        abortController: new AbortController(),
        isLoading: true,
        options: [],
      },
      filterPinnedItems: {
        abortController: new AbortController(),
        isLoading: true,
        options: [],
      },
    };

    this.funcs = {
      togglePin: this.togglePin.bind(this),
      setNavState: this.setState.bind(this),
    };
  }

  componentDidMount() {
    this.fetchFilterItems();
    this.fetchFilterPinnedItems();
  }

  componentDidUpdate(prevProps, prevState) {
    const viewMoreChanged = this.state.ViewMore !== prevState.ViewMore;
    const clientNumberChanged = prevProps.clientNumber !== this.props.clientNumber;
    const filterFieldChanged = this.props.filterFieldValue !== prevProps.filterFieldValue;

    if (filterFieldChanged || clientNumberChanged || viewMoreChanged) {
      this.fetchFilterItems();
      this.fetchFilterPinnedItems();
    }
  }

  fetchFilterItems() {
    this.state.filterItems.abortController.abort();
    const abortController = new AbortController();
    const params = {
      searchFields: this.props.filterFieldValue,
      clientNumber: this.props.isInternalUser ? this.props.clientNumber : undefined,
      ViewMore: this.state.ViewMore,
    };
    const URL = buildUrl(FILTERITEMS, params);

    this.setState({
      filterItems: {
        ...this.state.filterItems,
        options: [],
        abortController,
        isLoading: true,
      },
    });

    Fetch.Get(URL, { signal: abortController.signal })
      .then(response => response.json())
      .then((data) => {
        const options = (data.DataList || [])
          .filter(x => !x.Pinned)
          .filter(x => x.Description !== i18n.t('common:Not Specified'))
          .map(x => ({ value: x.Description }))
          .sort((a, b) => Number(a.value < b.value));

        this.setState({
          filterItems: {
            ...this.state.filterItems,
            options,
            isLoading: false,
          },
        });
        this.props.setAppState({
          filterItemValue: '',
        });
      });
  }

  fetchFilterPinnedItems() {
    this.state.filterPinnedItems.abortController.abort();
    const abortController = new AbortController();
    const params = {
      searchFields: this.props.filterFieldValue,
      clientNumber: this.props.isInternalUser ? this.props.clientNumber : undefined,
      ViewMore: true,
    };
    const URL = buildUrl(FILTERITEMS, params);

    this.setState({
      filterPinnedItems: {
        ...this.state.filterPinnedItems,
        options: [],
        abortController,
        isLoading: true,
      },
    });

    Fetch.Get(URL, { signal: abortController.signal })
      .then(response => response.json())
      .then((data) => {
        const options = (data.DataList || [])
          .filter(x => x.Pinned)
          .map(x => ({ value: x.Description }))
          .sort((a, b) => Number(a.value < b.value));

        this.setState({
          filterPinnedItems: {
            ...this.state.filterPinnedItems,
            options,
            isLoading: false,
          },
        });
      });
  }

  togglePin(value, isPinned) {
    const HttpMethod = isPinned ? 'Delete' : 'Post';
    let selectedFilterItem;

    if (isPinned) {
      selectedFilterItem = this.state.filterPinnedItems.options.find(x => x.value === value);

      this.setState((prevState) => {
        const i = prevState.filterPinnedItems.options.findIndex(x => x.value === value);

        return ({
          filterItems: {
            ...prevState.filterItems,
            options: [
              ...prevState.filterItems.options,
              prevState.filterPinnedItems.options[i],
            ],
          },
          filterPinnedItems: {
            ...prevState.filterPinnedItems,
            options: [
              ...prevState.filterPinnedItems.options.slice(0, i),
              ...prevState.filterPinnedItems.options.slice(i + 1),
            ],
          },
        });
      });
    } else {
      selectedFilterItem = this.state.filterItems.options.find(x => x.value === value);

      this.setState((prevState) => {
        const i = prevState.filterItems.options.findIndex(x => x.value === value);

        return ({
          filterItems: {
            ...prevState.filterItems,
            options: [
              ...prevState.filterItems.options.slice(0, i),
              ...prevState.filterItems.options.slice(i + 1),
            ],
          },
          filterPinnedItems: {
            ...prevState.filterPinnedItems,
            options: [
              ...prevState.filterPinnedItems.options,
              prevState.filterItems.options[i],
            ],
          },
        });
      });
    }

    Fetch[HttpMethod](PINFILTERITEM, {
      DataField: this.props.filterFieldValue,
      Description: selectedFilterItem.value,
      Pinned: !isPinned,
      clientNumber: this.props.isInternalUser ? this.props.clientNumber : undefined,
    }).catch(err => log.error(err));
  }

  render() {
    const { state, props, funcs } = this;

    return (
      <ContentSwitch index={props.deviceIndex} {...state} {...props} {...funcs}>
        <NavMobile />
        <NavDesktop />
      </ContentSwitch>
    );
  }
}

Nav.propTypes = {
  clientNumber: PropTypes.string,
  filterFieldValue: PropTypes.string,
  setAppState: PropTypes.func,
  isInternalUser: PropTypes.bool,
};

export default props => (
  <AppContext.Consumer>
    {context => (
      <Nav
        {...props}
        isInternalUser={context.isInternalUser}
      />
    )}
  </AppContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/containers/Nav/Nav.jsx